var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"minesweeper-cell",class:_vm.getClass()},[(_vm.cell.isOpen && _vm.cell.bombCount)?_c('div',[_vm._v("\n    "+_vm._s(_vm.cell.bombCount)+"\n  ")]):_vm._e(),(_vm.cell.hasFlag)?_c('div',[_vm._v("\n    ⚑\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }